import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=4fcabda2&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=4fcabda2&lang=scss&scoped=true&"
import style1 from "./Orders.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcabda2",
  null
  
)

export default component.exports